import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  intlShape,
  injectIntl,
  FormattedMessage,
  FormattedNumber
} from 'react-intl';

import {
  Accordion,
  AccordionPanel,
  Button,
  Icon,
  Modal
} from '@salesforce/design-system-react';

import './DeactivateWeatherModal.scss';

class DeactivateWeatherModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'deactivateWeather';
    this.getI18nID = suffix =>
      `components.ecs.setup.deactivateWeather.${suffix}`;
    this.state = {
      expandedPanels: {}
    };
  }

  isOpen() {
    return !!this.props.modals[this.modalName]?.isOpen;
  }

  togglePanel(id) {
    this.setState(state => ({
      expandedPanels: {
        ...state.expandedPanels,
        [id]: !state.expandedPanels[id]
      }
    }));
  }

  renderModal() {
    const { formatMessage } = this.props.intl;

    const {
      weatherAssetClasses,
      weatherAttributes,
      weatherAssetCount
    } = this.props;

    const assetClassSummary = formatMessage(
      {
        id: this.getI18nID('assetClass.summary')
      },
      { count: weatherAssetClasses.length }
    );
    const assetClassDetails = formatMessage({
      id: this.getI18nID('assetClass.details')
    });

    const attributeSummary = formatMessage(
      {
        id: this.getI18nID('attribute.summary')
      },
      { count: weatherAttributes.length }
    );
    const attributeDetails = formatMessage({
      id: this.getI18nID('attribute.details')
    });

    const helpLink =
      'https://help.salesforce.com/articleView?id=mc_pb_einstein_content_selection.htm&type=5';

    return (
      <div className="deactivate-weather-modal">
        <div className="destructive-warning">
          <div style={{ color: 'black' }}>
            <div className="slds-current-color centered-icon">
              <Icon
                assistiveText={{ label: 'Warning' }}
                category="utility"
                name="warning"
                size="small"
              />
            </div>
          </div>
          <FormattedMessage
            id={this.getI18nID('deactivateWarning')}
            values={{
              link: (
                <a rel="noopener noreferrer" target="_blank" href={helpLink}>
                  {formatMessage({
                    id: 'components.ecs.nocatalog.helpLinkText'
                  })}
                </a>
              )
            }}
          />
        </div>
        <div className="deactivate-weather-modal-content">
          <Accordion>
            <AccordionPanel
              id="asset-class-panel"
              summary={assetClassSummary}
              expanded={!!this.state.expandedPanels.assetClass}
              onTogglePanel={() => this.togglePanel('assetClass')}
            >
              <div className="list-panel">
                {weatherAssetClasses.length > 0 ? (
                  <span>{assetClassDetails}</span>
                ) : null}
                <ul className="bulleted">
                  {weatherAssetClasses.map(wac => (
                    <li key={`asset-class-li-${wac.uuid}`}>{wac.name}</li>
                  ))}
                </ul>
              </div>
            </AccordionPanel>
            <AccordionPanel
              id="attribute-panel"
              summary={attributeSummary}
              expanded={!!this.state.expandedPanels.attribute}
              onTogglePanel={() => this.togglePanel('attribute')}
            >
              <div className="list-panel">
                {weatherAttributes.length > 0 ? (
                  <span>{attributeDetails}</span>
                ) : null}
                <ul className="bulleted">
                  {weatherAttributes.map(attr => (
                    <li key={`attribute-li-${attr.uuid}`}>{attr.name}</li>
                  ))}
                </ul>
              </div>
            </AccordionPanel>
          </Accordion>
          <div className="asset-label">
            <FormattedMessage id={this.getI18nID('asset.summary')} />
            <FormattedNumber value={weatherAssetCount} />
          </div>
        </div>
      </div>
    );
  }

  renderFooter() {
    const { formatMessage } = this.props.intl;

    /**
     * Cancel
     */
    const cancelLabel = formatMessage({ id: this.getI18nID('cancel') });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={() => this.props.actions.closeModal(this.modalName)}
      />
    );

    /**
     * Deactivate & Delete button
     */
    const deleteButton = (
      <Button
        label={formatMessage({ id: this.getI18nID(`deactivateButton`) })}
        variant="destructive"
        onClick={() => {
          this.props.onSubmit();
        }}
      />
    );

    return (
      <div className="footer-button-actions">
        {cancelButton}
        {deleteButton}
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <Modal
        className={this.modalName}
        heading={formatMessage({ id: this.getI18nID('heading') })}
        footer={this.renderFooter()}
        onRequestClose={() => this.props.actions.closeModal(this.modalName)}
        dismissOnClickOutside={false}
        disableClose={true}
        isOpen={this.isOpen()}
      >
        {this.renderModal()}
      </Modal>
    );
  }
}

DeactivateWeatherModal.propTypes = {
  actions: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  weatherAssetClasses: PropTypes.array,
  weatherAttributes: PropTypes.array,
  weatherAssetCount: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(DeactivateWeatherModal);
